import React, { useEffect} from "react";
import { observer } from 'mobx-react';
import pabsStore from './Stores/SurveyStore';
import ibsStore from './Stores/IbsSurveyStore';
import {getSurveyErrorSummaryCtrl } from "../control"
import { CURRENT_DATA_YEAR } from '../Enums/constants'
import { NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';


const SurveyPage = observer((props) => {
    useEffect(() => {
        if (!(props.pageName in pabsStore.surveyMappingObj)) {
            pabsStore.surveyMappingObj[props.pageName] = [];
        }

        window.scrollTo(0, 0);
        //hide side nav if screen is small
        if (window.innerWidth < 1600) {
            pabsStore.showSideNav = false;
        } 
        pabsStore.additionalInfoPanel.visible = false;
        pabsStore.currentURL = window.location.href;

        if (pabsStore.currentLandedPage == "submit") {
            getSurveyErrorSummaryCtrl();
        }
    }, [props.pageName]);
    
    var elemIndex = pabsStore.availPageTitles.findIndex(item => pabsStore.currentLandedPage.toLowerCase() === item.toLowerCase());

    var showNextLink = elemIndex != pabsStore.availPageTitles.length - 1

    let termsAndConditionsSigned = ibsStore.currentSurvey && (ibsStore.currentSurvey.isAgreed || ibsStore.currentSurvey.DataYear < CURRENT_DATA_YEAR);
    const footer = (props.noFooter || termsAndConditionsSigned === false) ? <></> : (
        <div className="footer">
            {pabsStore.currentLandedPage.toLowerCase() != "submit" && pabsStore.currentLandedPage.toLowerCase() != "unlock" && showNextLink &&
                <NavLink tag={Link} to={pabsStore.nextPagePath} className="nextSection"> Go to next section &gt;</NavLink>
            }
            {pabsStore.currentLandedPage.toLowerCase() != "home" && pabsStore.currentLandedPage.toLowerCase() != "unlock" &&
                <NavLink tag={Link} to={pabsStore.previousPagePath} className="previousSection">&lt; Go to previous
                    section </NavLink>
            }
        </div>
    )
    //var showFooter = props.showFooter === undefined || ((pabsStore.surveyTypeUrl == SurveyTypeURL.DB || pabsStore.surveyTypeUrl == SurveyTypeURL.DC) && ibsStore.currentSurvey);

    /* Resize listener for NavMenu */
    useEffect(() => {
        const handleResize = () => {
            /* On resize, compare to navbar as the navbar height may change between desktop/mobile */
            let navBarDiv = document.querySelector("div.fixed-top");
            let navBar = document.querySelector("div.fixed-top > nav.navbar");
            let navbarSpacer = document.querySelector("#navbarSpacer");

            let actualNavHeight = Math.max(navBarDiv.clientHeight, navBar.clientHeight);
            navbarSpacer.style.height = `${actualNavHeight}px`;
        }
        handleResize();
        window.addEventListener("resize", handleResize, { passive: true });
        return () => window.removeEventListener("resize", handleResize);
    });

    return (
        <div className="page" style={props.style}>
            <div id="navbarSpacer"></div>
            {props.children}
            {footer}
        </div>
    );
});
export default SurveyPage;
